/**
 * Format a number with commas or whatever is locale-appropriate.
 * @param value Original numeric value.
 * @returns     String value of the number.
 */
export default function (value: number): string {
    
    value = Math.round(value);

    if (value.toLocaleString) {
        return value.toLocaleString();
    }

    return value.toString();
    
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/globals/utilities/format-number.ts